import React, {Component} from "react";
import bingoGen from "../../js/bingoGen"

class TakahashiBingo extends Component{

    constructor(){
        super()
        this.state = {
            bingoData: bingoGen("takahashi"),
        }
    }

    refresh(){
        this.setState({bingoData: bingoGen("takahashi")});
    }

    render(){
        return(
            <main>
                <h2>takahashi bingo</h2>
                <p>Yuya Takahashi is already the most prolific Kamen Rider writer of the Reiwa era, having both <i>Kamen Rider Zero-One</i> and <i>Kamen Rider Geats</i> under his belt in the period after debuting with <i>Kamen Rider Ex-Aid</i> in Heisei Phase 2. He is also the writer of the current season, <i>Kamen Rider Zeztz</i>. Takahashi is not an uncontroversial writer, with fans often falling on one side or another with his work. While these bingo cards may not apply to all of his seasons, these tropes can often be found in at least two of his seasons.</p>
                <table className="bingoTable">
                    <thead>
                        <th>B</th>
                        <th>I</th>
                        <th>N</th>
                        <th>G</th>
                        <th>O</th>
                    </thead>
                    <tbody>
                        {this.state.bingoData.map((val, key) => {
                            return(
                                <tr>
                                    {val.map((v, k) => {
                                        return(
                                            <td><p>{v}</p></td>
                                        )
                                    })}
                                </tr>
                            )
                        })}
                    </tbody>
                </table>
                <div className="refresh">
                    <button className="btn-center" onClick={()=>{this.refresh()}}><h2>Click to generate a new bingo card.</h2></button>
                </div>
            </main>
        );
    }
}

export default TakahashiBingo;